export default "__VITE_ASSET__0F0uUjXn__"